import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Button,
  Link,
  FormControlLabel,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { colorTags } from "../../constants/variants";
import {
  useGetNotificationsQuery,
  useGetNotificationByIdQuery,
  useCreateNotificationRequestMutation,
  useUpdateNotificationRequestMutation,
  useDeleteNotificationRequestMutation,
  useMarkNotificationAsReadRequestMutation,
} from "../../features/api/apiSlice";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";

const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow:
      "rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
    overflow: "auto",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2), // Add margin at the bottom for separation
  },
  cardHeader: {
    backgroundColor: "#fff",
    color: colorTags.PRIMARY,
    fontSize: "1rem",
  },
  cardActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  link: {
    color: colorTags.PRIMARY,
  },
  listItem: {
    marginBottom: theme.spacing(1), // Add margin at the bottom for separation
  },
}));

const Notifications = ({ open, onClose }) => {
  const classes = useStyles();

  const [token, setToken] = useState(localStorage.getItem("authToken"));
  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const [isChecked, setIsChecked] = useState(false);
  const [openRead, setOpenRead] = useState(false);
  const [
    markAllAsRead,
    { isLoading: isMarkLoading, isError: isMarkError, error: markError },
  ] = useMarkNotificationAsReadRequestMutation();
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setOpenRead(!isChecked);
  };
  // const {
  //   data: notificationsData,
  //   isLoading: notificationsLoading,
  //   isError: isErrorNotifications,
  //   error: notificationsError,
  // } = useGetNotificationsQuery();
  const {
    data: notificationsData,
    isLoading: notificationsLoading,
    isError: isErrorNotifications,
    error: notificationsError,
  } = useGetNotificationByIdQuery({ id: user && user?.user_id });

  const [groupedNotifications, setGroupedNotifications] = useState([]);
  console.log(user);

  useEffect(() => {
    if (notificationsData) {
      setGroupedNotifications(
        notificationsData.reduce((acc, notification) => {
          const date = new Date(notification.notif_date).toLocaleDateString(
            "en-US"
          );
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(notification);
          return acc;
        }, {})
      );
    }
  }, [notificationsData]);
  const handleMarkAllAsRead = async (e) => {
    // setOpenRead(true)
    e.preventDefault();
    await markAllAsRead({ id: user?.user_id })
      .then((res) => {
        if (res.data) {
          setOpenRead(false);
          setIsChecked(false);
        }
      })
      .catch((err) => {
        toast.error("something went wrong");
      });
  };
  return (
    <Card className={classes.card} open={open} onClose={onClose}>
      <CardHeader title="Notifications" className={classes.cardHeader} />
      <Divider />
      <div className={classes.cardActions}>
        {notificationsData && notificationsData.length > 0 && (
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                color="success"
              />
            }
            label="Mark all as read"
          />
        )}
        {openRead && (
          <LoadingButton
            loading={isMarkLoading}
            style={{ color: colorTags.SECONDARY }}
            onClick={handleMarkAllAsRead}>
            Save
          </LoadingButton>
        )}
        {notificationsData && notificationsData.length > 0 && (
          <Link
            className={classes.link}
            href={
              user?.role_name === "member" || user?.role_name === "Member"
                ? "/notifications"
                : "/dashboard/notifications"
            }>
            View All
          </Link>
        )}
      </div>
      <List>
        {Object.entries(groupedNotifications).map(([date, notifications]) => (
          <React.Fragment key={date}>
            <ListItem className={classes.listItem}>
              <ListItemText primary={date} />
            </ListItem>
            {notifications?.map((notification) => (
              <ListItem key={notification.id} className={classes.listItem}>
                <ListItemText
                  primary={notification.message}
                  secondary={new Date(
                    notification.notif_date
                  ).toLocaleDateString("en-US")}
                  secondaryTypographyProps={{ align: "right" }}
                />
              </ListItem>
            ))}
          </React.Fragment>
        ))}
      </List>
    </Card>
  );
};

export default Notifications;
